import React from 'react';
import { CheckCircle, AlertTriangle, Info, X } from 'lucide-react';
import { useNotification } from '../context/NotificationContext';

export function NotificationBanner() {
    const { notification, hideNotification } = useNotification();

    if (!notification.visible) return null;

    // New style: White card, shadow, rounded, centered or floating
    // The screenshot suggests a clean white card with black text and a specific icon style.
    // We'll position it fixed at the bottom-right or top-center. Let's go with bottom-right for a standard toast feel,
    // or centered if it looks like a modal alert. The user said "centered" in the prompt description I inferred.
    // Let's try fixed bottom-6 right-6 z-50 for a non-intrusive but visible toast.

    const getIcon = () => {
        switch (notification.type) {
            case 'success':
                return <div className="bg-black rounded-full p-1"><CheckCircle className="h-4 w-4 text-white" /></div>;
            case 'error':
                return <div className="bg-red-600 rounded-full p-1"><AlertTriangle className="h-4 w-4 text-white" /></div>;
            case 'warning':
                return <div className="bg-yellow-500 rounded-full p-1"><AlertTriangle className="h-4 w-4 text-white" /></div>;
            case 'info':
            default:
                return <div className="bg-blue-600 rounded-full p-1"><Info className="h-4 w-4 text-white" /></div>;
        }
    };

    return (
        <div className="fixed bottom-6 right-6 z-[100] transition-all duration-300 ease-in-out transform translate-y-0 opacity-100">
            <div className="bg-white dark:bg-zinc-950 border border-border shadow-2xl rounded-xl p-4 max-w-md flex items-start gap-4">
                <div className="mt-1 flex-shrink-0">
                    {getIcon()}
                </div>
                <div className="flex-1 pt-0.5">
                    <p className="text-[14px] font-medium text-foreground leading-snug">
                        {notification.message}
                    </p>
                </div>
                <button
                    onClick={hideNotification}
                    className="text-muted-foreground hover:text-foreground transition-colors -mt-1 -mr-1 p-1"
                >
                    <X className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
}
